// extracted by mini-css-extract-plugin
module.exports = {"wrapp":"search_component_wrapp__nXzbV","fixed":"search_component_fixed__JrCV2"};